const HOST = "https://seerah-be.valortutors.com"
// const HOST = "http://192.168.29.225:4000"

export { HOST }